import api from './api';
import types from './mutation-types';

export default {
	getSqlIds_: ({ state, commit }, payload) => {
		return api
			.getSqlIds(payload)
			.then(data => {
				const { header, body } = data;
				const { code } = header;
				const { pagingInfo, resultList } = body;
				if (code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'pagingInfo',
						value: pagingInfo
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'sqlIds',
						value: resultList
					});
				}
				return header;
			})
			.catch(error => {
				throw error;
			});
	},
	getFullSqlIds_: ({ state, commit }, payload) => {
		return api
			.getSqlIds(payload)
			.then(data => {
				const { header, body } = data;
				const { code } = header;
				const { pagingInfo, resultList } = body;
				if (code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'fullSqlIds',
						value: resultList
					});
					// console.warn('Build tree....');
					commit(types.TREE_LIST, resultList);
				}
				return header;
			})
			.catch(error => {
				throw error;
			});
	},
	getSqlContent_: ({ state, commit }, payload) => {
		return api
			.getSqlContent(payload)
			.then(data => {
				const { header, body } = data;
				const { code } = header;
				if (code === 0) {
					commit(types.ADD_CONTENTS, {
						key: 'sqlContent',
						value: body[0]
					});
				}
				return header;
			})
			.catch(error => {
				throw error;
			});
	},
	getSqlLog_: ({ state, commit }, payload) => {
		return api
			.getSqlLog(payload)
			.then(data => {
				const { header, body } = data;
				const { code } = header;
				if (code === 0) {
					if (body.length != 0) {
						// commit(types.ADD_LOGS, {
						// 	key: 'sqlLog',
						// 	value: body
						// });
						commit(types.ADD_LOGS, {
							key: 'sqlContent',
							value: { sqlId: payload, body }
						});
					}
				}
				return header;
			})
			.catch(error => {
				throw error;
			});
	},

	postCompileSql_({ state, commit, dispatch }, payload) {
		return api
			.postCompileSql(payload)
			.then(data => {
				const { header, body } = data;
				const { code } = header;
				if (code === 0) {
					commit(types.ADD_COMPILES, {
						key: 'sqlContent',
						value: { sqlId: payload.sqlId, ...body }
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'selectedContent',
						value: { ...state.selectedContent, BindSqlText: body.sql, StaticSqlText: body.staticSql }
					});
				}
				return header;
			})
			.catch(error => {
				throw error;
			});
	},

	postExeSql_({ state, commit }, payload) {
		return api
			.postExeSql(payload)
			.then(data => {
				if (data.header.code === 0) {
					if (data.body === null) {
					} else {
						// console.log('data.body', data.body);
						// console.log('JSON.parse(data.body)', JSON.parse(data.body));
						const parseResult = JSON.parse(data.body);
						// const parseResult = JSON.parse(data.body).Table;
						if (parseResult.length != 0) {
							commit(types.DEFAULT_ASSIGN, { key: 'popupParams', value: { show: true, result: parseResult } });
						} else {
							data.header.isnull = true;
						}
					}
				}
				return data.header;
			})
			.catch(error => {
				commit(types.SET_MODAL_STATE, { result: null, compileFlag: false });
				throw error;
			});
	},

	postUpdateSql_: ({ commit, dispatch }, payload) => {
		return api
			.postUpdateSql(payload)
			.then(data => {
				const { header, body } = data;

				const { code } = header;
				if (code === 0) {
				}
				return header;
			})
			.catch(error => {
				throw error;
			});
	},

	postDeleteSql_: ({ commit, dispatch }, payload) => {
		return api
			.postDeleteSql(payload)
			.then(data => {
				const { header, body } = data;
				const { code } = header;
				if (code === 0) {
				}
				return header;
			})
			.catch(error => {
				throw error;
			});
	},
	exportXml_: ({ state, commit }) => {
		return api
			.exportXml()
			.then(data => {
				const { header, body } = data;
				const { code } = header;
				if (code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'xmlData',
						value: body
					});
				} else if (code === -1) {
				}
				return header;
			})
			.catch(error => {
				throw error;
			});
	},
	importXml_: ({ state, commit }, payload) => {
		return api
			.importXml(payload)
			.then(data => {
				const { header, body } = data;
				const { code } = header;
				return header;
			})
			.catch(error => {
				throw error;
			});
	}
};
